var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBawsalaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8595 36.0018L57.955 20.3468L42.2875 67.6876C40.9339 71.7945 43.1355 76.2312 47.2049 77.5973C51.2743 78.9634 55.6706 76.7415 57.0242 72.6346L77.5936 10.3276C78.5334 7.51336 77.8142 4.40482 75.7367 2.30159C73.6592 0.198372 70.5813 -0.53726 67.7898 0.402263L6.05063 21.1922C3.17565 21.8463 0.916404 24.0883 0.219948 26.9783C-0.476509 29.8683 0.51017 32.9069 2.76638 34.8205C5.02258 36.734 8.15846 37.1917 10.8595 36.0018Z",
    fill: "#E30000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBawsalaIcon);
export default __webpack_public_path__ + "static/media/bawsalaIcon.d951c99dc59e6c7648917fdc786d55a8.svg";
export { ForwardRef as ReactComponent };